/// <amd-module name="Build/Pipelines/PipelineScheduledRunsDataService" />
import { ScheduledRun, ScheduledRunsData } from "Build/Client/Contracts/DataProvider";
import { IReadyableReadonlyObservableArray, ReadyableObservableArray, ObservableValue, IReadonlyObservableValue} from 'VSS/Core/Observable';
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export interface IPipelineScheduledRunsDataService extends IVssService {
    data: IReadyableReadonlyObservableArray<ScheduledRun>;
    hasDesignerSchedule: IReadonlyObservableValue<Boolean>;
    refreshData: (definitionId: number, syncSchedulesNow: Boolean) => void;
}

class PipelineScheduledRunsDataService extends VssService implements IPipelineScheduledRunsDataService {
    private _data: ReadyableObservableArray<ScheduledRun>;
    private _hasDesignerSchedule: ObservableValue<Boolean>;
    
    public get data(): IReadyableReadonlyObservableArray<ScheduledRun> {
        return this._data;
    }

    public get hasDesignerSchedule(): IReadonlyObservableValue<Boolean> {
        return this._hasDesignerSchedule;
    }

    public refreshData(definitionId: number, syncSchedulesNow: Boolean) {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        this._data.ready.value = false;
        this._hasDesignerSchedule = new ObservableValue<Boolean>(false);
        contributionService.getDataAsync<ScheduledRunsData>("ms.vss-build-web.pipeline-scheduled-runs-data-provider", 
        {definitionId: definitionId.toString(), syncSchedulesNow}, true).then((value: ScheduledRunsData | undefined) => {
            if (value) {
                this._data.value = value.scheduledRuns;
                this._hasDesignerSchedule.value = value.hasDesignerSchedule;
                this._data.ready.value = true;
            }
        });
    }

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._initialize();
    }

    public _serviceRestart(pageContext: IVssPageContext): void {
        super._serviceRestart(pageContext);
        this._initialize();
    }

    private _initialize() {
        this._data = new ReadyableObservableArray<ScheduledRun>(undefined);
    }
}

Services.add("IPipelineScheduledRunsDataService", { serviceFactory: PipelineScheduledRunsDataService });

